<div class="serial-section modal-box">
    <button mat-icon-button class="close-button" (click)="cancel()">
        <mat-icon>close</mat-icon>
    </button>
    <div *ngIf="isPVCMake">
      <h3>Choose PVC or Serial Range</h3>
      <mat-form-field class="range-field" appearance="fill">
        <mat-label>PVC</mat-label>
        <input matInput [(ngModel)]="pvc" placeholder="Enter PVC if applicable"  
        (ngModelChange)="onPvcChange($event)"
        [readonly]="selectedMode === 'RANGE'"
        (click)="handleDisabledClick('PVC')" />
      </mat-form-field>
    </div>
    <h3>Set serial number range</h3>
    <div *ngFor="let range of serialRanges; let i = index" class="serial-range">
      <mat-form-field class="range-field">
        <mat-label>From</mat-label>
        <input matInput [(ngModel)]="range.from"
        (ngModelChange)="onRangeChange()"
        [readonly]="selectedMode === 'PVC'"
        (click)="handleDisabledClick('RANGE')" />
      </mat-form-field>
      <mat-form-field class="range-field">
        <mat-label>To</mat-label>
        <input matInput [(ngModel)]="range.to" 
        (ngModelChange)="onRangeChange()"
        [readonly]="selectedMode === 'PVC'"
        (click)="handleDisabledClick('RANGE')"/>
      </mat-form-field>

      <button
        mat-icon-button
        color="warn"
        *ngIf="serialRanges.length > 1"
        (click)="removeSerialRange(i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div class="exclusion-buttons">
      <button
        mat-stroked-button
        class="outlined-blue-button add-range-button"
        (click)="addSerialRange()"
      >
        ➕ SERIAL NUMBER RANGE
      </button>
    </div>
  
    <h3>Set exclusions</h3>
    <div *ngFor="let exclusion of serialExclusions; let i = index" class="serial-range">
      <mat-form-field class="range-field" *ngIf="exclusion.from !== undefined">
        <mat-label>From</mat-label>
        <input matInput [(ngModel)]="exclusion.from" />
      </mat-form-field>
      <mat-form-field class="range-field" *ngIf="exclusion.to !== undefined">
        <mat-label>To</mat-label>
        <input matInput [(ngModel)]="exclusion.to" />
      </mat-form-field>

      <mat-form-field class="range-field" *ngIf="exclusion.value !== undefined">
        <input matInput [(ngModel)]="exclusion.value" />
      </mat-form-field>

      <button mat-icon-button color="warn" (click)="removeExclusion(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  
    <div class="exclusion-buttons">
        <button mat-stroked-button class="outlined-blue-button" (click)="addIndividualExclusion()">➕ INDIVIDUAL SERIAL NUMBER EXCLUSION</button>
        <button mat-stroked-button class="outlined-blue-button" (click)="addRangeExclusion()">➕ SERIAL NUMBER RANGE EXCLUSION</button>
    </div>
  <div style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 10px;">
    <button mat-raised-button class="discard-button" (click)="cancel()">
        <mat-icon>close</mat-icon>
        DISCARD
      </button>
      <button mat-raised-button class="confirm-button" (click)="confirm()">
        <mat-icon>check</mat-icon>
        CONFIRM
      </button>
  </div>
  